// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgPronoun: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M12.225 10.73a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" />
        <path d="M11.775 11.48a4.8 4.8 0 0 0-4.8 4.8 1.2 1.2 0 0 0 1.2 1.2h8.1a1.2 1.2 0 0 0 1.2-1.2 4.8 4.8 0 0 0-4.8-4.8z" />
        <path
          fillRule="evenodd"
          d="M24 12c0 2.612-.835 5.03-2.252 7 .152.302.797 1.739 1.372 3.12.432 1.04-.443 2.058-1.55 1.848l-4.866-.925A11.961 11.961 0 0 1 12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12m-3.194 9.787-4.327-.823-.56.24A9.962 9.962 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c0 2.18-.695 4.19-1.876 5.832l-.708.985.546 1.083c.085.17.438.946.844 1.887"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgPronoun);
export default Memo;
